import { Permission } from "@octopusdeploy/octopus-server-client";
import type { GitRef, TemplateResourceBase } from "@octopusdeploy/octopus-server-client";
import { noOp } from "@octopusdeploy/utilities";
import * as React from "react";
import { useEffect, useState } from "react";
import semver from "semver/preload";
import type { TemplateWizardPageProps } from "~/areas/platformHub/TemplateWizardDialogLayout";
import TemplateWizardDialogLayout from "~/areas/platformHub/TemplateWizardDialogLayout";
import type { ReleaseType } from "~/areas/platformHub/processTemplates/PublishTemplateDialog";
import { PublishTemplateDialog } from "~/areas/platformHub/processTemplates/PublishTemplateDialog";
import CustomDialog from "~/components/Dialog/CustomDialog";
export interface PublishWizardTemplate extends TemplateResourceBase {
}
export interface PublishWizardVersion {
    Version: string;
    IsPreRelease: boolean;
}
export interface PublishProjectTemplateWizardDialogProps {
    open: boolean;
    busy: boolean;
    errors: Error[];
    template: PublishWizardTemplate;
    gitRef: GitRef;
    publishedVersions: PublishWizardVersion[];
    closeDialog: () => void;
    onPublish: (params: {
        versionToPublish: string;
        isPreRelease: boolean;
        releaseType: ReleaseType;
        releaseNotes: string;
    }) => Promise<void>;
    hasUnsupportedSteps: boolean;
}
export function PublishProjectTemplateWizardDialog({ open, busy, errors, template, gitRef, publishedVersions, onPublish, hasUnsupportedSteps }: PublishProjectTemplateWizardDialogProps) {
    const defaultVersion = "1.0.0";
    const latestNonPreReleaseVersion = publishedVersions.find((v) => !semver.prerelease(v.Version));
    const [versionToPublish, setVersionToPublish] = useState<string>(latestNonPreReleaseVersion ? (semver.inc(latestNonPreReleaseVersion.Version, "major") ?? defaultVersion) : defaultVersion);
    const [releaseType, setReleaseType] = useState<ReleaseType>("Major");
    const [isPreRelease, setIsPreRelease] = useState<boolean>(false);
    const [releaseNotes, setReleaseNotes] = useState<string>("");
    const [hasSaveBeenAttempted, setHasSaveBeenAttempted] = useState<boolean>(false);
    useEffect(() => {
        const latest = publishedVersions.find((v) => !semver.prerelease(v.Version));
        const next = latest ? (semver.inc(latest.Version, "major") ?? defaultVersion) : defaultVersion;
        setVersionToPublish(next);
    }, [publishedVersions]);
    const pages: TemplateWizardPageProps[] = [
        {
            title: "Publish version",
            content: (<PublishTemplateDialog gitRef={gitRef} template={template} templateType={"project"} publishedVersions={publishedVersions} versionToPublish={versionToPublish} setVersionToPublish={setVersionToPublish} latestNonPreReleaseVersion={latestNonPreReleaseVersion} isPreRelease={isPreRelease} setIsPreRelease={setIsPreRelease} releaseType={releaseType} setReleaseType={setReleaseType} releaseNotes={releaseNotes} setReleaseNotes={setReleaseNotes} hasUnsupportedSteps={hasUnsupportedSteps}/>),
            actionAvailable: !hasUnsupportedSteps,
            statusBarLabel: "Publish",
            singlePageSaveLabel: "Publish",
            singlePageSavingLabel: "Publishing...",
        },
    ];
    const shouldShowErrors = errors && hasSaveBeenAttempted && !busy;
    return (<CustomDialog open={open} close={noOp} render={() => (<TemplateWizardDialogLayout onSaveClick={async () => {
                setHasSaveBeenAttempted(true);
                await onPublish({ versionToPublish, isPreRelease, releaseType, releaseNotes });
                setReleaseNotes("");
                return true;
            }} busy={busy} errors={shouldShowErrors ? errors : undefined} savePermission={{ permission: Permission.PlatformHubEdit }} pages={pages}/>)}/>);
}
export default PublishProjectTemplateWizardDialog;
